import { faInfoCircle, faStickyNote, faTruck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Checkbox, Col, DatePicker, Divider, Icon, Input, InputNumber, message, Modal, Pagination, Popover, Row, Select, Spin, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import DashboardIndicator from "../components/dashboard-elements/DashboardIndicator";
import OrderInfoSection from "../components/dashboard-elements/OrderInfoSection";
import OrderTimeline from "../components/dashboard-elements/OrderTimeline";
import ProductList from "../components/dashboard-elements/ProductList";
import LeafletPackingOrders from "../components/map/LeafletPackingOrders";
import parseCurrency from "../functions/parseCurrency";
import ApiCoreV2 from "../utils/ApiConnection/OliverCore/ApiService";
import AuthService from "../utils/AuthService";
import Mispichoshelper, { MispichosVars } from "../utils/Mispichoshelper";
import { Notes } from "../componentsPetshop/orderActions/OrderInfo";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const authService = new AuthService();

const { RangePicker } = DatePicker;

export const PACKING_ORDER_STATUS = {
    CREATED: 1,
    PICKED: 2,
    PACKED: 3,
    SHIPPED: 4,
    CANCELED: 5,
    LABEL_PRINTED: 7
};

export const TRANSPORT_ORDER_STATUS = {
    TO_BE_PICKED_UP: 1,
    DISPATCHED: 2,
    IN_TRANSIT: 3,
    DELIVERED: 4,
    PARTIALLY_DELIVERED: 5,
    DELAYED: 6,
    CANCELED: 7,
    CLIENT_NOT_IN_ADDRESS: 8,
    SECOND_DELIVERY_ATTEMPT: 9,
    RETURN_TO_ORIGIN: 10,
    RETURNED_TO_ORIGIN: 11
};

export const getPackingStatusColor = (statusId) => {
    switch (statusId) {
        case PACKING_ORDER_STATUS.CREATED:
            return '#e6bc68ff';
        case PACKING_ORDER_STATUS.PICKED:
        case PACKING_ORDER_STATUS.PACKED:
        case PACKING_ORDER_STATUS.LABEL_PRINTED:
            return '#ffe58f';
        case PACKING_ORDER_STATUS.SHIPPED:
            return '#ccf2ccff';
        case PACKING_ORDER_STATUS.CANCELED:
            return '#efc7c7ff';
        default:
            return '#959595ff';
    }
};

export const getLogisticStatusColor = (statusId) => {
    switch (statusId) {
        case TRANSPORT_ORDER_STATUS.TO_BE_PICKED_UP:
            return '#ffe58f';
        case TRANSPORT_ORDER_STATUS.IN_TRANSIT:
            return '#bfdbf3ff';
        case TRANSPORT_ORDER_STATUS.SECOND_DELIVERY_ATTEMPT:
            return '#fdedb7ff';
        case TRANSPORT_ORDER_STATUS.DISPATCHED:
            return '#bfdbf3ff';
        case TRANSPORT_ORDER_STATUS.DELIVERED:
            return '#abdfacff';
        case TRANSPORT_ORDER_STATUS.PARTIALLY_DELIVERED:
            return '#4caf50';
        case TRANSPORT_ORDER_STATUS.DELAYED:
            return '#f6b83bff';
        case TRANSPORT_ORDER_STATUS.CANCELED:
        case TRANSPORT_ORDER_STATUS.RETURN_TO_ORIGIN:
            return '#efc7c7ff';
        case TRANSPORT_ORDER_STATUS.CLIENT_NOT_IN_ADDRESS:
            return '#b40101ff';
        case TRANSPORT_ORDER_STATUS.RETURNED_TO_ORIGIN:
            return '#ff9800';
        default:
            return '#e1e1e1ff';
    }
};

const DashboardPetshop = () => {

    const petProfile = authService.getProfile();
    const isAdmin = petProfile.rol === 'admin' || petProfile.rol === 'atencion cliente';

    const [filterModalVisible, setFilterModalVisible] = useState(false);

    // Filtros principales
    const [selectedIndicator, setSelectedIndicator] = useState('todos');
    const [selectedPeriod, setSelectedPeriod] = useState('hoy');
    const [customDateRange, setCustomDateRange] = useState(null);
    const [datePickerVisible, setDatePickerVisible] = useState(false);
    const [orders, setOrders] = useState([]);
    const [loadingOrders, setLoadingOrders] = useState(true);
    const [filterDate, setFilterDate] = useState(moment());
    const [orderStatus, setOrderStatus] = useState(null);
    const [filterTransporter, setFilterTransporter] = useState(null);
    const [filterPackingOrder, setFilterPackingOrder] = useState(null);

    // Filtros Indicadores Atemporales
    const [filterDelayed, setFilterDelayed] = useState(null);
    const [filterPickUpFromClient, setFilterPickUpFromClient] = useState(null);
    const [filterReturnToOrigin, setFilterReturnToOrigin] = useState(null);
    const [filterInTransit, setFilterInTransit] = useState(null);

    const [brands, setBrands] = useState([]);
    const [packingStatuses, setPackingStatuses] = useState([]);
    const [transportStatuses, setTransportStatuses] = useState([]);
    const [localities, setLocalities] = useState([]);
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [deliveryTimes, setDeliveryTimes] = useState([]);
    const [selectedDeliveryTime, setSelectedDeliveryTime] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDetailVisible, setOrderDetailVisible] = useState(false);
    const [searchOrderNumber, setSearchOrderNumber] = useState('');
    const [tempSearchOrderNumber, setTempSearchOrderNumber] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [counters, setCounters] = useState({
        all_orders: 0,
        pending_to_print_label: 0,
        to_be_dispatched: 0,
        in_transit: 0,
        return_to_origin: 0,
        canceled: 0,
        pick_up_from_client_address: 0,
        delayed: 0
    });
    // Paginación
    const [paginationPerPage, setPaginationPerPage] = useState(50);
    const [paginationTotal, setPaginationTotal] = useState(0);
    const [paginationCurrentPage, setPaginationCurrentPage] = useState(1);
    const [paginationFrom, setPaginationFrom] = useState(null);
    const [paginationTo, setPaginationTo] = useState(null);
    const [paginationCheck, setPaginationCheck] = useState(true);

    const [petshops, setPetshops] = useState([]);
    const [filters, setFilters] = useState({
        fechaDesde: null,
        fechaHasta: null,
        montoDesde: 0,
        montoHasta: null,
        producto: '',
        metodoPago: 'todos',
        estadoPaquete: 'todos',
        estadoLogistico: 'todos',
        repartidor: 'todos',
        provincia: 'Buenos Aires',
        localidad: null,
        barrio: null,
        codigoPostal: '',
        puv_id: null
    });
    const [viewMode, setViewMode] = useState('lista'); // 'lista' o 'mapa'
    const [cancelSaleModalVisible, setCancelSaleModalVisible] = useState(false);
    const [cancelMotive, setCancelMotive] = useState(null);
    const [cancelComment, setCancelComment] = useState('');
    const [outStockProducts, setOutStockProducts] = useState([]);
    const [selectedOutStockProducts, setSelectedOutStockProducts] = useState([]);
    const [loadingOutStockProducts, setLoadingOutStockProducts] = useState(false);
    const [confirmCancelModalVisible, setConfirmCancelModalVisible] = useState(false);
    const [repackageModalVisible, setRepackageModalVisible] = useState(false);
    const [repackageLabelType, setRepackageLabelType] = useState('pdf');
    const [notes, setNotes] = useState([]);
    const requestIdRef = useRef(0);

    useEffect(() => {
        getOrders();
        setSelectedRowKeys([]);
        setSelectedOrders([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderStatus, filterTransporter, filterPackingOrder, filterPickUpFromClient, filterDelayed, filterReturnToOrigin, filterInTransit, customDateRange, filterDate, searchOrderNumber, selectedDeliveryTime, filters]);

    useEffect(() => {
        getPackingAndTransportStatuses();
        getLocalitiesAndNeighborhoods();
        getDrivers();
        getDeliveryTimes();
        if (isAdmin) {
            getPetshopList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Auto-refresh de órdenes cada 5 minutos
    useEffect(() => {
        const intervalId = setInterval(() => {
            getOrders(paginationCurrentPage);
        }, 300000);

        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationCurrentPage, orderStatus, filterTransporter, filterPackingOrder, filterPickUpFromClient, filterDelayed, filterReturnToOrigin, filterInTransit, customDateRange, filterDate, searchOrderNumber, selectedDeliveryTime, filters]);

    // Get orders al cambiar paginación
    useEffect(() => {
        getOrders();
    }, [paginationCheck]);

    const getPetshopList = () => {
        Mispichoshelper.getPetshopList({ full: 1 }).then((response) => {
            if (response.status && response.payload) {
                setPetshops(response.payload);
            }
        });
    }

    const getOrders = async (page = 1, resetFilters = false) => {
        // -- un requestId para cada nuevo request
        requestIdRef.current += 1;
        const myRequestId = requestIdRef.current;

        setLoadingOrders(true);
        setOrders([]);

        try {
            const params = {
                user_id: petProfile.id
            };

            // Paginacion
            if (paginationCheck) {
                params.page = page;
                params.per_page = paginationPerPage;
            }

            // Filtro de fecha
            if (selectedPeriod === 'hoy' || selectedPeriod === 'proximos') {
                const dateStr = filterDate.format('YYYY-MM-DD');
                params.date = dateStr;
            } else if (customDateRange && customDateRange.length === 2) {
                params.date_from = customDateRange[0].format('YYYY-MM-DD');
                params.date_to = customDateRange[1].format('YYYY-MM-DD');
            }

            if (!resetFilters) {

                if (searchOrderNumber && searchOrderNumber.trim() !== '') {
                    params.order_number = searchOrderNumber.trim();
                }

                if (filterTransporter) {
                    params.transport_order_status = filterTransporter;
                }

                if (filterPackingOrder) {
                    params.packing_order_status = filterPackingOrder;
                }

                // Filtros indicadores atemporales

                if (filterDelayed) {
                    params.delayed = filterDelayed;
                }

                if (filterPickUpFromClient) {
                    params.pick_up_from_client_address = filterPickUpFromClient;
                }

                if (filterReturnToOrigin) {
                    params.return_to_origin = filterReturnToOrigin;
                }

                if (filterInTransit) {
                    params.in_transit = filterInTransit;
                }

                // Filtros del modal (solo enviar si tienen contenido)

                if (filters.fechaDesde) {
                    params.date_from = filters.fechaDesde.format('YYYY-MM-DD');
                }

                if (filters.fechaHasta) {
                    params.date_to = filters.fechaHasta.format('YYYY-MM-DD');
                }

                if (filters.montoDesde && filters.montoDesde > 0) {
                    params.amount_from = filters.montoDesde * 100; // Convertir a centavos
                }

                if (filters.montoHasta) {
                    params.amount_to = filters.montoHasta * 100; // Convertir a centavos
                }

                if (filters.metodoPago && filters.metodoPago !== 'todos') {
                    params.payment_method = filters.metodoPago;
                }

                if (filters.estadoPaquete && filters.estadoPaquete !== 'todos') {
                    params.packing_order_status = filters.estadoPaquete;
                }

                if (filters.estadoLogistico && filters.estadoLogistico !== 'todos') {
                    params.transport_order_status = filters.estadoLogistico;
                }

                if (filters.repartidor && filters.repartidor !== 'todos') {
                    params.driver_id = filters.repartidor;
                }

                if (filters.localidad) {
                    params.locality = filters.localidad;
                }

                if (filters.barrio) {
                    params.neighborhood = filters.barrio;
                }

                if (filters.codigoPostal) {
                    params.postal_code = filters.codigoPostal;
                }

                if (filters.puv_id) {
                    params.puv_id = filters.puv_id;
                }

                if (selectedDeliveryTime && selectedDeliveryTime.length > 0) {
                    params.delivery_times = selectedDeliveryTime.map(dt => ({
                        from: dt.start,
                        to: dt.end
                    }));
                }
            }

            const response = await ApiCoreV2.Petshops.getOrders(params);

            // -- actualiza sólo con el último request ejecutado, ignorando los que quedaron pendientes
            if (myRequestId === requestIdRef.current && response.data) {
                setOrders(response.data.orders || []);
                setCounters(response.data.counters || {
                    all_orders: 0,
                    pending_to_print_label: 0,
                    to_be_dispatched: 0,
                    in_transit: 0,
                    return_to_origin: 0,
                    canceled: 0,
                    pick_up_from_client_address: 0
                });

                // Paginacion
                if (response.data.pagination) {
                    setPaginationCurrentPage(response.data.pagination.current_page ? parseInt(response.data.pagination.current_page, 10) : 1);
                    setPaginationTotal(response.data.pagination.total || 0);
                    setPaginationFrom(response.data.pagination.from || null);
                    setPaginationTo(response.data.pagination.to || null);
                }
            }
        } catch (error) {
            if (myRequestId === requestIdRef.current) {
                setOrders([]);
            }
        } finally {
            // -- actualiza sólo con el último request ejecutado, ignorando los que quedaron pendientes
            if (myRequestId === requestIdRef.current) {
                setLoadingOrders(false);
            }
        }
    };

    const getBrands = () => {
        Mispichoshelper.getBrandsGeneral().then(response => {
            if (response?.payload) {
                setBrands(response.payload)
            }
        });
    }

    const handleFilterChange = (field, value) => {
        setFilters({ ...filters, [field]: value });
    };

    const hasActiveFilters = () => {
        return (
            searchOrderNumber !== '' ||
            (selectedDeliveryTime && selectedDeliveryTime.length > 0) ||
            filters.fechaDesde !== null ||
            filters.fechaHasta !== null ||
            (filters.montoDesde !== null && filters.montoDesde > 0) ||
            filters.montoHasta !== null ||
            filters.producto !== '' ||
            (filters.metodoPago !== 'todos' && filters.metodoPago !== '') ||
            (filters.estadoPaquete !== 'todos' && filters.estadoPaquete !== '') ||
            (filters.estadoLogistico !== 'todos' && filters.estadoLogistico !== '') ||
            (filters.repartidor !== 'todos' && filters.repartidor !== '') ||
            // No incluimos provincia porque es un valor fijo que no cambia
            filters.localidad !== null ||
            filters.barrio !== null ||
            filters.codigoPostal !== ''
        );
    };

    const getActiveFilters = () => {
        const activeFilters = [];

        // Búsqueda por número de orden
        if (searchOrderNumber !== '') {
            activeFilters.push({
                key: 'searchOrderNumber',
                label: `Orden: ${searchOrderNumber}`,
                onRemove: () => {
                    setSearchOrderNumber('');
                    setTempSearchOrderNumber('');
                }
            });
        }

        // Franjas horarias
        if (selectedDeliveryTime && selectedDeliveryTime.length > 0) {
            selectedDeliveryTime.forEach((dt) => {
                activeFilters.push({
                    key: `deliveryTime_${dt.id}`,
                    label: `Franja: ${dt.formatted}`,
                    onRemove: () => {
                        const newTimes = selectedDeliveryTime.filter(t => t.id !== dt.id);
                        setSelectedDeliveryTime(newTimes);
                    }
                });
            });
        }

        // Rango de fechas
        if (filters.fechaDesde !== null || filters.fechaHasta !== null) {
            const desde = filters.fechaDesde ? filters.fechaDesde.format('DD/MM/YYYY') : '-';
            const hasta = filters.fechaHasta ? filters.fechaHasta.format('DD/MM/YYYY') : '-';
            activeFilters.push({
                key: 'dateRange',
                label: `Fechas: ${desde} - ${hasta}`,
                onRemove: () => {
                    setFilters({ ...filters, fechaDesde: null, fechaHasta: null });
                }
            });
        }

        // Monto desde
        if (filters.montoDesde !== null && filters.montoDesde > 0) {
            activeFilters.push({
                key: 'montoDesde',
                label: `Monto desde: $${filters.montoDesde}`,
                onRemove: () => setFilters({ ...filters, montoDesde: 0 })
            });
        }

        // Monto hasta
        if (filters.montoHasta !== null) {
            activeFilters.push({
                key: 'montoHasta',
                label: `Monto hasta: $${filters.montoHasta}`,
                onRemove: () => setFilters({ ...filters, montoHasta: null })
            });
        }

        // Método de pago
        if (filters.metodoPago !== 'todos' && filters.metodoPago !== '') {
            const metodoPagoLabel = filters.metodoPago === '1' ? 'Efectivo' : 'Tarjeta';
            activeFilters.push({
                key: 'metodoPago',
                label: `Pago: ${metodoPagoLabel}`,
                onRemove: () => setFilters({ ...filters, metodoPago: 'todos' })
            });
        }

        // Estado del paquete
        if (filters.estadoPaquete !== 'todos' && filters.estadoPaquete !== '') {
            const status = packingStatuses.find(s => s.id === filters.estadoPaquete);
            activeFilters.push({
                key: 'estadoPaquete',
                label: `Estado paquete: ${status?.text_pet || filters.estadoPaquete}`,
                onRemove: () => setFilters({ ...filters, estadoPaquete: 'todos' })
            });
        }

        // Estado logístico
        if (filters.estadoLogistico !== 'todos' && filters.estadoLogistico !== '') {
            const status = transportStatuses.find(s => s.id === filters.estadoLogistico);
            activeFilters.push({
                key: 'estadoLogistico',
                label: `Estado logístico: ${status?.text_pet || filters.estadoLogistico}`,
                onRemove: () => setFilters({ ...filters, estadoLogistico: 'todos' })
            });
        }

        // Repartidor
        if (filters.repartidor !== 'todos' && filters.repartidor !== '') {
            const driver = drivers.find(d => d.id === filters.repartidor);
            activeFilters.push({
                key: 'repartidor',
                label: `Repartidor: ${driver?.name || filters.repartidor}`,
                onRemove: () => setFilters({ ...filters, repartidor: 'todos' })
            });
        }

        // Localidad
        if (filters.localidad !== null) {
            const locality = localities.find(l => l.value === filters.localidad);
            activeFilters.push({
                key: 'localidad',
                label: `Localidad: ${locality?.text || filters.localidad}`,
                onRemove: () => setFilters({ ...filters, localidad: null })
            });
        }

        // Barrio
        if (filters.barrio !== null) {
            const neighborhood = neighborhoods.find(n => n.value === filters.barrio);
            activeFilters.push({
                key: 'barrio',
                label: `Barrio: ${neighborhood?.text || filters.barrio}`,
                onRemove: () => setFilters({ ...filters, barrio: null })
            });
        }

        // Código postal
        if (filters.codigoPostal !== '') {
            activeFilters.push({
                key: 'codigoPostal',
                label: `Código Postal: ${filters.codigoPostal}`,
                onRemove: () => setFilters({ ...filters, codigoPostal: '' })
            });
        }

        // Petshop (solo para admin)
        if (filters.puv_id) {
            const petshop = petshops.find(p => p.id === filters.puv_id);
            activeFilters.push({
                key: 'puv_id',
                label: `Petshop: ${petshop?.nombre || filters.puv_id}`,
                onRemove: () => setFilters({ ...filters, puv_id: null })
            });
        }

        return activeFilters;
    };

    const handleApplyFilters = () => {
        setFilterModalVisible(false);
        getOrders();
    };

    const handleClearFilters = () => {
        // Limpiar filtros del modal
        setFilters({
            fechaDesde: null,
            fechaHasta: null,
            montoDesde: 0,
            montoHasta: null,
            producto: '',
            metodoPago: 'todos',
            estadoPaquete: 'todos',
            estadoLogistico: 'todos',
            repartidor: 'todos',
            provincia: 'Buenos Aires',
            localidad: null,
            barrio: null,
            codigoPostal: '',
            puv_id: null
        });

        // Limpiar filtros de indicadores
        setSelectedIndicator('todos');
        setOrderStatus(null);
        setFilterTransporter(null);
        setFilterPackingOrder(null);
        setFilterPickUpFromClient(null);
        setFilterDelayed(null);

        // Limpiar franja horaria
        setSelectedDeliveryTime([]);

        // Limpiar búsqueda por número de orden
        setSearchOrderNumber('');
        setTempSearchOrderNumber('');

        setFilterModalVisible(false);
        getOrders(1, true);
    };

    const getPackingAndTransportStatuses = async () => {
        try {
            const [packingResponse, transportResponse] = await Promise.all([
                ApiCoreV2.Petshops.getPackingOrderStatuses(),
                ApiCoreV2.Petshops.getTransportOrderStatuses()
            ]);

            if (packingResponse?.data?.statuses) {
                setPackingStatuses(packingResponse.data?.statuses);
            }

            if (transportResponse?.data?.statuses) {
                setTransportStatuses(transportResponse.data?.statuses);
            }
        } catch (error) {
            console.error('Error al obtener estados:', error);
        }
    }

    const getLocalitiesAndNeighborhoods = async () => {
        try {
            const [localitiesResponse, neighborhoodsResponse] = await Promise.all([
                ApiCoreV2.Addresses.getLocalities(),
                ApiCoreV2.Addresses.getNeighborhoods()
            ]);

            if (localitiesResponse?.data?.localities) {
                setLocalities(localitiesResponse.data.localities);
            }

            if (neighborhoodsResponse?.data?.neighborhoods) {
                setNeighborhoods(neighborhoodsResponse.data.neighborhoods);
            }
        } catch (error) {
            console.error('Error al obtener localidades y barrios:', error);
        }
    }

    const getDrivers = async () => {
        try {
            const driversResponse = await ApiCoreV2.DeliveryDrivers.getDrivers();

            if (driversResponse?.data?.drivers) {
                setDrivers(driversResponse.data.drivers);
            }
        } catch (error) {
            console.error('Error al obtener drivers:', error);
        }
    }

    const getDeliveryTimes = async () => {
        try {
            const deliveryTimesResponse = await ApiCoreV2.DeliveryTimes.getDeliveryTimes();

            if (deliveryTimesResponse?.data) {
                setDeliveryTimes(deliveryTimesResponse.data);
            }
        } catch (error) {
            console.error('Error al obtener franjas horarias:', error);
        }
    }

    const handleIndicatorClick = (indicatorId) => {
        if (selectedIndicator === indicatorId) {
            if (indicatorId !== 'todos') {
                setSelectedIndicator('todos');
                setOrderStatus(null);
                setFilterTransporter(null);
                setFilterPackingOrder(null);
                setFilterPickUpFromClient(null);
                setFilterDelayed(null);
            }
        } else {
            setSelectedIndicator(indicatorId);

            switch (indicatorId) {
                case 'todos':
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder(null);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(null);
                    break;
                case 'imprimir':
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder(PACKING_ORDER_STATUS.CREATED);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(null);
                    break;
                case 'despachar':
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder([PACKING_ORDER_STATUS.LABEL_PRINTED]);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(null);
                    break;
                case 'cancelada':
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder(PACKING_ORDER_STATUS.CANCELED);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(null);
                    break;
                // INDICADORES ATEMPORALES
                case 'demorados':
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder(null);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(true);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(null);
                    break;
                case 'retirar':
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder(null);
                    setFilterPickUpFromClient(true);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(null);
                    break;
                case 'retornar':
                    setOrderStatus(null);
                    setFilterTransporter();
                    setFilterPackingOrder(null);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(true);
                    setFilterInTransit(null);
                    break;
                case 'encamino':
                    setOrderStatus(null);
                    setFilterTransporter([TRANSPORT_ORDER_STATUS.IN_TRANSIT, TRANSPORT_ORDER_STATUS.SECOND_DELIVERY_ATTEMPT, TRANSPORT_ORDER_STATUS.DISPATCHED]);
                    setFilterPackingOrder(null);
                    setFilterPickUpFromClient(null);

                    setFilterDelayed(null);
                    setFilterReturnToOrigin(null);
                    setFilterInTransit(true);
                    break;
                default:
                    setOrderStatus(null);
                    setFilterTransporter(null);
                    setFilterPackingOrder(null);
                    setFilterPickUpFromClient(null);
                    setFilterDelayed(null);
            }
        }
    };

    const handlePeriodClick = (period) => {
        setSelectedPeriod(period);
        setCustomDateRange(null);

        let newDate;
        if (period === 'hoy') {
            newDate = moment();
        } else if (period === 'proximos') {
            newDate = moment().add(1, 'days');
        }

        setFilterDate(newDate);
    };

    const handleDateRangeChange = (dates) => {
        setCustomDateRange(dates);
        setDatePickerVisible(false);
        if (dates) {
            setSelectedPeriod(null);
        }
    };

    const handleOrderClick = (order) => {
        setSelectedOrder(order);
        setOrderDetailVisible(true);
    };

    const handleSelectChange = (selectedKeys, selectedRows) => {
        setSelectedRowKeys(selectedKeys);
        const ordersMap = selectedRows.map(row => orders.find(o => o.id === row.orden));
        setSelectedOrders(ordersMap);
    };

    const handleMapOrderSelect = (order) => {
        const key = order.id;

        // Usar la forma funcional de setState para garantizar el estado más reciente
        setSelectedRowKeys(prevKeys => {
            const isAlreadySelected = prevKeys.includes(key);

            if (isAlreadySelected) {
                // Deselect
                return prevKeys.filter(k => k !== key);
            } else {
                // Select
                return [...prevKeys, key];
            }
        });

        setSelectedOrders(prevOrders => {
            const isAlreadySelected = prevOrders.some(o => o.id === key);

            if (isAlreadySelected) {
                // Deselect
                return prevOrders.filter(o => o.id !== key);
            } else {
                // Select
                return [...prevOrders, order];
            }
        });
    };

    // Función modular para generar y descargar etiquetas
    const generateAndDownloadLabels = async (orderIds, type = 'pdf') => {
        try {
            const labelsResponse = await ApiCoreV2.Petshops.generateLabels({
                order_ids: orderIds,
                type: type
            });

            if (labelsResponse instanceof Blob) {
                const url = window.URL.createObjectURL(labelsResponse);
                const link = document.createElement('a');
                link.href = url;
                const extension = type === 'zpl' ? 'txt' : 'pdf';
                link.download = `etiquetas_${moment().format('YYYY-MM-DD_HH-mm')}.${extension}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                return true;
            }
            return false;
        } catch (labelError) {
            console.error('Error al generar etiquetas:', labelError);
            message.error('Hubo un error al generar las etiquetas');
            return false;
        }
    };

    const prepareDataForExcel = () => {
        return selectedOrders.map(order => {
            const address = order.address
                ? `${order.address.dom_calle || ''} ${order.address.dom_altura || ''}, ${order.address.dom_piso ? `Piso ${order.address.dom_piso}` : ''} - ${order.address.dom_ciudad || ''} (${order.address.dom_codigo_postal || ''})`
                : 'N/A';

            const productos = order.products?.map(p => `${p.pro_nombre_completo} (x${p.quantity})`).join('; ') || 'Sin productos';

            return {
                purchaseOrder: order.com_id,
                packingOrder: order.id,
                trackingNumber: order.tracking_number || 'N/A',
                fechaEntrega: order.delivery_date_formatted,
                estadoPaquete: order.actual_package_status || 'N/A',
                estadoLogistico: order.actual_logistic_status || '-',
                domicilio: address,
                productos: productos,
                sku: order.products?.map(p => p.ppv_internal_sku ?? p.prv_codigo_barra ?? 'N/A').join('; ') || 'N/A',
                monto: parseCurrency(order.total_real),
                cliente: `${order.buyer?.nombre || ''} ${order.buyer?.apellido || ''}`.trim() || 'N/A',
                clienteDNI: isAdmin ? order.buyer?.dni || 'N/A' : 'N/A',
                clienteTelefono: isAdmin ? order.buyer?.telefono || 'N/A' : 'N/A',
                clienteEmail: isAdmin ? order.buyer?.email || 'N/A' : 'N/A',
                metodoPago: order.payment_method_id === 1 ? 'Efectivo' : 'Tarjeta',
                petshop: order.puv_nombre || 'N/A',
                repartidor: order.transport_order?.user ? `${order.transport_order.user.nombre || ''} ${order.transport_order.user.apellido || ''}`.trim() : 'N/A',
                fechaCreacionOrdenCompra: order.order.com_fecha_in,
            };
        });
    };

    const getActionButton = () => {
        if (selectedOrders.length === 0) return null;

        // Verificar si todas las órdenes tienen estado "Retorno al origen"
        const allReturnToOrigin = selectedOrders.every(order =>
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.RETURN_TO_ORIGIN ||
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.RETURNED_TO_ORIGIN
        );

        const someReturnToOrigin = selectedOrders.some(order =>
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.RETURN_TO_ORIGIN ||
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.RETURNED_TO_ORIGIN
        );

        // Verificar si todas las órdenes tienen estado "Pendiente de despacho"
        const allToBePickedUp = selectedOrders.every(order =>
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.TO_BE_PICKED_UP
        );

        const someToBePickedUp = selectedOrders.some(order =>
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.TO_BE_PICKED_UP
        );

        // Verificar si todas las órdenes tienen el mismo estado para mostrar el botón correspondiente
        const allCreated = selectedOrders.every(order => order.status?.id === PACKING_ORDER_STATUS.CREATED);
        const someCreated = selectedOrders.some(order => order.status?.id === PACKING_ORDER_STATUS.CREATED);

        const allLabelPrinted = selectedOrders.every(order => order.status?.id === PACKING_ORDER_STATUS.LABEL_PRINTED);
        const someLabelPrinted = selectedOrders.some(order => order.status?.id === PACKING_ORDER_STATUS.LABEL_PRINTED);

        const allPacked = selectedOrders.every(order => order.status?.id === PACKING_ORDER_STATUS.PACKED);
        const somePacked = selectedOrders.some(order => order.status?.id === PACKING_ORDER_STATUS.PACKED);

        const allCanceled = selectedOrders.every(order => order.status?.id === PACKING_ORDER_STATUS.CANCELED);
        const someCanceled = selectedOrders.some(order => order.status?.id === PACKING_ORDER_STATUS.CANCELED);

        const allDispatched = selectedOrders.every(order =>
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.DISPATCHED
        );
        const someDispatched = selectedOrders.some(order =>
            order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.DISPATCHED
        );

        const allEligibleForRepackage = selectedOrders.every(order =>
            order.status?.id === PACKING_ORDER_STATUS.SHIPPED &&
            (order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.IN_TRANSIT ||
                order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.DISPATCHED ||
                order.transport_order?.status?.id === TRANSPORT_ORDER_STATUS.SECOND_DELIVERY_ATTEMPT)
        );

        // Verificar estados mixtos de TRANSPORTE (no mezclar con estados de paquete)
        const hasMixedTransportStates =
            (someReturnToOrigin && !allReturnToOrigin) ||
            // (someToBePickedUp && !allToBePickedUp) || TODO: HASTA LIMPIAR PEDIDOS VIEJOS
            (someDispatched && !allDispatched) ||
            (allReturnToOrigin && (someToBePickedUp || someDispatched)) ||
            (allToBePickedUp && (someReturnToOrigin || someDispatched)) ||
            (allDispatched && (someReturnToOrigin || someToBePickedUp));

        // Verificar estados mixtos de PAQUETE (no mezclar con estados de transporte)
        const hasMixedPackingStates =
            (someCreated && !allCreated) ||
            (someLabelPrinted && !allLabelPrinted) ||
            (somePacked && !allPacked) ||
            (someCanceled && !allCanceled) ||
            (allCreated && (someLabelPrinted || somePacked || someCanceled)) ||
            (allLabelPrinted && (someCreated || somePacked || someCanceled)) ||
            (allPacked && (someCreated || someLabelPrinted || someCanceled)) ||
            (allCanceled && (someCreated || someLabelPrinted || somePacked));

        const hasMixedStates = hasMixedTransportStates || hasMixedPackingStates;

        if (hasMixedStates) {
            return {
                type: 'warning',
                message: 'No se pueden accionar órdenes con diferentes estados'
            };
        }

        if (allReturnToOrigin) {
            return {
                type: 'action',
                label: 'Retornado',
                action: handleRetornado,
                color: '#ff9800',
                textColor: '#fff'
            };
        }

        if (allCreated) {
            return {
                type: 'multiple',
                buttons: [
                    {
                        label: 'Imprimir etiqueta',
                        action: handleEmpaquetar,
                        color: 'rgba(41, 84, 255, 1)',
                        textColor: '#fff'
                    },
                    {
                        label: 'Imprimir etiqueta Zebra',
                        action: handleEmpaquetarZebra,
                        color: '#ffffffff',
                        textColor: '#282828ff'
                    }
                ]
            };
        }

        // Reimprimir etiqueta: para "Pendiente de despacho" (LABEL_PRINTED)
        if (allLabelPrinted) {
            return {
                type: 'multiple',
                buttons: [
                    {
                        label: 'Reimprimir etiqueta',
                        action: handleReimprimirEtiqueta,
                        color: 'rgba(41, 84, 255, 1)',
                        textColor: '#fff'
                    },
                    {
                        label: 'Reimprimir etiqueta Zebra',
                        action: handleReimprimirEtiquetaZebra,
                        color: '#ffffffff',
                        textColor: '#2c2c2cff'
                    }
                ]
            };
        }

        // Cancelar: para "Pendiente de despacho" (TO_BE_PICKED_UP) o "Empaquetado" (PACKED)
        if (allToBePickedUp || allPacked) {
            return {
                type: 'action',
                label: 'Cancelar',
                action: handleCancelar,
                color: '#ef4444',
                textColor: '#fff'
            };
        }
        if (allEligibleForRepackage) {
            return {
                type: 'action',
                label: 'Re empaquetar',
                action: handleReEmpaquetar,
                color: '#ff9800',
                textColor: '#fff'
            };
        }

        // Si están despachadas, no mostrar ningún botón
        if (allDispatched) {
            return null;
        }

        if (!allCanceled) {
            return {
                type: 'action',
                label: 'Cancelar',
                action: handleCancelar,
                color: '#ef4444',
                textColor: '#fff'
            };
        }

        return null;
    };

    const bulkChangeStatus = async (statusId) => {
        try {
            setLoadingOrders(true);
            // Extraer los IDs de las órdenes de empaquetado
            const packingOrderIds = selectedOrders.map(order => order.id);

            const response = await ApiCoreV2.Customer.changePackingOrderStatus({
                packing_order_ids: packingOrderIds,
                status_id: statusId
            });

            if (response.success || response.data) {
                const data = response.data || response;
                const totalUpdated = data.total_updated || 0;
                const totalErrors = data.total_errors || 0;
                const updatedOrders = data.updated_orders || [];
                console.log("UPDATED ORDERS", updatedOrders);
                const errors = data.errors || [];

                // Si se empaquetaron órdenes exitosamente, generar etiquetas
                if (statusId === PACKING_ORDER_STATUS.LABEL_PRINTED && totalUpdated > 0) {
                    const orderIds = selectedOrders.map(order => order.id);
                    const success = await generateAndDownloadLabels(orderIds, 'pdf');

                    if (!success) {
                        message.warning('Órdenes empaquetadas correctamente, pero hubo un error al generar las etiquetas');
                    }
                }

                // Construir contenido del modal
                const modalContent = (
                    <div>
                        <div style={{ marginBottom: '16px' }}>
                            <strong style={{ color: '#52c41a' }}>
                                ✓ Órdenes actualizadas: {totalUpdated}
                            </strong>
                        </div>
                        {statusId === PACKING_ORDER_STATUS.LABEL_PRINTED && totalUpdated > 0 && (
                            <div style={{ marginBottom: '16px', padding: '8px', backgroundColor: '#e6f7ff', borderRadius: '4px', border: '1px solid #91d5ff' }}>
                                <strong style={{ color: '#1890ff' }}>
                                    📄 Etiquetas descargadas automáticamente
                                </strong>
                            </div>
                        )}
                        {totalErrors > 0 && (
                            <div style={{ marginBottom: '16px' }}>
                                <strong style={{ color: '#ff4d4f' }}>
                                    ✗ Errores: {totalErrors}
                                </strong>
                            </div>
                        )}

                        {updatedOrders.length > 0 && (
                            <div style={{ marginTop: '12px' }}>
                                <div style={{ fontWeight: '600', marginBottom: '8px' }}>Órdenes actualizadas:</div>
                                <div style={{ maxHeight: '150px', overflow: 'auto', backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
                                    {updatedOrders.map((order, index) => (
                                        <div key={index} style={{ padding: '4px 0', fontSize: '12px' }}>
                                            • OE #{order.packing_order_id} | OC #{order.com_id}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {errors.length > 0 && (
                            <div style={{ marginTop: '12px' }}>
                                <div style={{ fontWeight: '600', marginBottom: '8px', color: '#ff4d4f' }}>Errores:</div>
                                <div style={{ maxHeight: '150px', overflow: 'auto', backgroundColor: '#fff2f0', padding: '8px', borderRadius: '4px', border: '1px solid #ffccc7' }}>
                                    {errors.map((error, index) => (
                                        <div key={index} style={{ padding: '4px 0', fontSize: '12px', color: '#cf1322' }}>
                                            • {error.id ? `Orden #${error.id}: ` : ''}{error.message || error.error || JSON.stringify(error)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );

                // Mostrar modal con resultados
                Modal.info({
                    title: 'Resultado de la actualización',
                    content: modalContent,
                    width: 600,
                    okText: 'Cerrar',
                    onOk: () => {
                        // Recargar las órdenes después de cerrar el modal
                        getOrders();
                        // Limpiar selección
                        setSelectedRowKeys([]);
                        setSelectedOrders([]);
                    }
                });
            } else {
                message.error(`Error al actualizar estado: ${response.message || 'Error desconocido'}`);
            }
        } catch (error) {
            console.error('Error al actualizar estado:', error);
            message.error('Error al actualizar el estado de las órdenes');
        } finally {
            setLoadingOrders(false);
        }
    };

    const handleEmpaquetar = () => {
        Modal.confirm({
            title: '¿Confirmar empaquetado?',
            content: `¿Desea marcar como empaquetadas ${selectedOrders.length} orden(es) seleccionada(s)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk: () => {
                bulkChangeStatus(PACKING_ORDER_STATUS.LABEL_PRINTED);
            }
        });
    };

    const handleReimprimirEtiqueta = () => {
        Modal.confirm({
            title: '¿Reimprimir etiquetas?',
            content: `¿Desea reimprimir las etiquetas de ${selectedOrders.length} orden(es) seleccionada(s)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk: async () => {
                setLoadingOrders(true);
                const orderIds = selectedOrders.map(order => order.id);
                const success = await generateAndDownloadLabels(orderIds, 'pdf');

                if (success) {
                    message.success(`Etiquetas generadas exitosamente para ${selectedOrders.length} orden(es)`);
                    // Limpiar selección
                    setSelectedRowKeys([]);
                    setSelectedOrders([]);
                }

                setLoadingOrders(false);
            }
        });
    };

    const handleEmpaquetarZebra = () => {
        Modal.confirm({
            title: '¿Confirmar empaquetado con Zebra?',
            content: `¿Desea marcar como empaquetadas ${selectedOrders.length} orden(es) seleccionada(s) e imprimir etiquetas Zebra (ZPL)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk: async () => {
                setLoadingOrders(true);
                // Extraer los IDs de las órdenes de empaquetado
                const packingOrderIds = selectedOrders.map(order => order.id);

                try {
                    const response = await ApiCoreV2.Customer.changePackingOrderStatus({
                        packing_order_ids: packingOrderIds,
                        status_id: PACKING_ORDER_STATUS.LABEL_PRINTED
                    });

                    if (response.success || response.data) {
                        const data = response.data || response;
                        const totalUpdated = data.total_updated || 0;

                        if (totalUpdated > 0) {
                            const orderIds = selectedOrders.map(order => order.id);
                            const success = await generateAndDownloadLabels(orderIds, 'zpl');

                            if (success) {
                                message.success(`Órdenes empaquetadas y etiquetas Zebra generadas exitosamente`);
                            } else {
                                message.warning('Órdenes empaquetadas correctamente, pero hubo un error al generar las etiquetas Zebra');
                            }

                            getOrders();
                            setSelectedRowKeys([]);
                            setSelectedOrders([]);
                        }
                    }
                } catch (error) {
                    console.error('Error al empaquetar:', error);
                    message.error('Error al actualizar el estado de las órdenes');
                } finally {
                    setLoadingOrders(false);
                }
            }
        });
    };

    const handleReimprimirEtiquetaZebra = () => {
        Modal.confirm({
            title: '¿Reimprimir etiquetas Zebra?',
            content: `¿Desea reimprimir las etiquetas Zebra (ZPL) de ${selectedOrders.length} orden(es) seleccionada(s)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk: async () => {
                setLoadingOrders(true);
                const orderIds = selectedOrders.map(order => order.id);
                const success = await generateAndDownloadLabels(orderIds, 'zpl');

                if (success) {
                    message.success(`Etiquetas Zebra generadas exitosamente para ${selectedOrders.length} orden(es)`);
                    // Limpiar selección
                    setSelectedRowKeys([]);
                    setSelectedOrders([]);
                }

                setLoadingOrders(false);
            }
        });
    };

    const handleReEmpaquetar = () => {
        setRepackageLabelType('pdf');
        setRepackageModalVisible(true);
    };

    const handleConfirmRepackage = async () => {
        try {
            setLoadingOrders(true);
            const orderIds = selectedOrders.map(order => order.id);

            const response = await ApiCoreV2.Petshops.repackage({
                order_ids: orderIds,
                type: repackageLabelType
            });

            if (response instanceof Blob) {
                const extension = repackageLabelType === 'zpl' ? 'zpl' : 'pdf';
                const url = window.URL.createObjectURL(response);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `etiquetas_reempaquetado_${moment().format('YYYY-MM-DD_HH-mm')}.${extension}`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);

                message.success(`Re-empaquetado exitoso para ${selectedOrders.length} orden(es). Etiquetas descargadas.`);
                setSelectedRowKeys([]);
                setSelectedOrders([]);
                getOrders(paginationCurrentPage);
            } else {
                message.error('Error al generar las etiquetas de re-empaquetado');
            }
        } catch (error) {
            console.error('Error al re-empaquetar:', error);
            message.error('Error al procesar el re-empaquetado');
        } finally {
            setLoadingOrders(false);
            setRepackageModalVisible(false);
        }
    };

    const handleCancelar = () => {
        Modal.confirm({
            title: '¿Confirmar cancelación?',
            content: `¿Desea cancelar ${selectedOrders.length} orden(es) seleccionada(s)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            okType: 'danger',
            onOk: () => {
                bulkChangeStatus(PACKING_ORDER_STATUS.CANCELED);
            }
        });
    };

    const handleCancelarVenta = () => {
        setCancelSaleModalVisible(true);
        handleCancelMotiveChange(MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO);
    };

    const handleCompletarVenta = () => {
        Modal.confirm({
            title: '¿Confirmar completar pedido?',
            content: `¿Desea completar ${selectedOrders.length} orden(es) seleccionada(s)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            okType: 'primary',
            onOk: () => {
                completeDeliveryProcess();
            }
        });
    }

    const completeDeliveryProcess = async () => {
        setLoadingOrders(true);
        const params = {
            transport_order_ids: selectedOrders.map(order => order.transport_order?.id).filter(id => id !== undefined)
        };

        try {
            ApiCoreV2.TransportOrders.completeDeliveryProcess(params)
                .then(response => {
                    if (response.status) {
                        message.success(response.message);
                        setSelectedRowKeys([]);
                        setSelectedOrders([]);
                        getOrders();
                    } else {
                        message.error(response.message);
                    }
                });
        } catch (error) {
            console.error('error', error);
            Alert.error('Error al completar el proceso de entrega', 'Hubo un error al intentar completar el proceso de entrega. Por favor, intente nuevamente.');
        }
        setLoadingOrders(false);
    }

    const handleCancelMotiveChange = async (value) => {
        setCancelMotive(value);
        setOutStockProducts([]);
        setSelectedOutStockProducts([]);

        if (value === MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO && selectedOrders.length > 0) {
            setLoadingOutStockProducts(true);
            try {
                const order = selectedOrders[0];
                const response = await Mispichoshelper.Transporter.getConsultStock({ compra_id: order.com_id });
                if (response.status && response.payload && response.payload.productos) {
                    setOutStockProducts(response.payload.productos);
                }
            } catch (error) {
                console.error('Error al obtener productos:', error);
                message.error('Error al obtener los productos de la orden');
            } finally {
                setLoadingOutStockProducts(false);
            }
        }
    };

    const handleShowConfirmModal = () => {
        if (!cancelMotive) {
            message.error('Debe seleccionar un motivo de cancelación');
            return;
        }

        if (cancelMotive === MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO && selectedOutStockProducts.length === 0) {
            message.error('Debe seleccionar al menos un producto sin stock');
            return;
        }

        setConfirmCancelModalVisible(true);
    };

    const delegateCancelOrder = async () => {
        setConfirmCancelModalVisible(false);

        try {
            setLoadingOrders(true);

            const outStockProductsPayload = cancelMotive === MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO
                ? selectedOutStockProducts.map(product => ({
                    prv_id: product.prv_id,
                    prv_producto_nombre: product.prv_producto_nombre
                }))
                : null;

            let finalComment = cancelComment || '';
            if (cancelMotive === MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO && selectedOutStockProducts.length > 0) {
                const productNames = selectedOutStockProducts.map(p => p.prv_producto_nombre).join(', ');
                finalComment = `Comentarios: No tiene ${productNames}${cancelComment ? `. ${cancelComment}` : ''}`;
            }

            const promises = selectedOrders.map(async (order) => {
                const params = {
                    com_id: order.com_id,
                    mot_id: cancelMotive,
                    comment: finalComment,
                    out_stock_products: outStockProductsPayload
                };

                return Mispichoshelper.Transporter.postDelegateAcceptedOrder(params);
            });

            const responses = await Promise.all(promises);

            const allSuccess = responses.every(response => response.status || response.success);

            if (allSuccess) {
                message.success('Venta cancelada exitosamente');
                setCancelSaleModalVisible(false);
                setCancelMotive(null);
                setCancelComment('');
                setOutStockProducts([]);
                setSelectedOutStockProducts([]);
                setSelectedRowKeys([]);
                setSelectedOrders([]);
                getOrders();
            } else {
                message.error('Hubo un error al cancelar algunas ventas');
            }
        } catch (error) {
            console.error('Error al cancelar ventas:', error);
            message.error('Error al cancelar las ventas');
        } finally {
            setLoadingOrders(false);
        }
    };

    const bulkChangeTransportStatus = async (statusId) => {
        try {
            setLoadingOrders(true);
            // Extraer los IDs de las transport orders
            const packingOrderIds = selectedOrders.map(order => order.id);

            if (packingOrderIds.length === 0) {
                message.warning('No hay órdenes de transporte para actualizar');
                setLoadingOrders(false);
                return;
            }

            const response = await ApiCoreV2.Customer.changeTransportOrderStatus({
                packing_order_ids: packingOrderIds,
                status_id: statusId
            });

            if (response.success || response.data) {
                const data = response.data || response;
                const totalUpdated = data.total_updated || 0;
                const totalErrors = data.total_errors || 0;
                const updatedOrders = data.updated_orders || [];
                const errors = data.errors || [];

                // Construir contenido del modal
                const modalContent = (
                    <div>
                        <div style={{ marginBottom: '16px' }}>
                            <strong style={{ color: '#52c41a' }}>
                                ✓ Órdenes actualizadas: {totalUpdated}
                            </strong>
                        </div>
                        {totalErrors > 0 && (
                            <div style={{ marginBottom: '16px' }}>
                                <strong style={{ color: '#ff4d4f' }}>
                                    ✗ Errores: {totalErrors}
                                </strong>
                            </div>
                        )}

                        {updatedOrders.length > 0 && (
                            <div style={{ marginTop: '12px' }}>
                                <div style={{ fontWeight: '600', marginBottom: '8px' }}>Órdenes actualizadas:</div>
                                <div style={{ maxHeight: '150px', overflow: 'auto', backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
                                    {updatedOrders.map((order, index) => (
                                        <div key={index} style={{ padding: '4px 0', fontSize: '12px' }}>
                                            • Orden #{order.id}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {errors.length > 0 && (
                            <div style={{ marginTop: '12px' }}>
                                <div style={{ fontWeight: '600', marginBottom: '8px', color: '#ff4d4f' }}>Errores:</div>
                                <div style={{ maxHeight: '150px', overflow: 'auto', backgroundColor: '#fff2f0', padding: '8px', borderRadius: '4px', border: '1px solid #ffccc7' }}>
                                    {errors.map((error, index) => (
                                        <div key={index} style={{ padding: '4px 0', fontSize: '12px', color: '#cf1322' }}>
                                            • {error.id ? `Orden #${error.id}: ` : ''}{error.message || error.error || JSON.stringify(error)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );

                // Mostrar modal con resultados
                Modal.info({
                    title: 'Resultado de la actualización',
                    content: modalContent,
                    width: 600,
                    okText: 'Cerrar',
                    onOk: () => {
                        // Recargar las órdenes después de cerrar el modal
                        getOrders();
                        // Limpiar selección
                        setSelectedRowKeys([]);
                        setSelectedOrders([]);
                    }
                });
            } else {
                message.error(`Error al actualizar estado: ${response.message || 'Error desconocido'}`);
            }
        } catch (error) {
            console.error('Error al actualizar estado de transporte:', error);
            message.error('Error al actualizar el estado de las órdenes de transporte');
        } finally {
            setLoadingOrders(false);
        }
    };

    const handleRetornado = () => {
        Modal.confirm({
            title: '¿Confirmar retorno?',
            content: `¿Desea marcar como retornadas ${selectedOrders.length} orden(es) seleccionada(s)?`,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            okType: 'warning',
            onOk: () => {
                bulkChangeTransportStatus(TRANSPORT_ORDER_STATUS.RETURNED_TO_ORIGIN);
            }
        });
    };

    const getNotes = (order) => {
        var params = { com_id: order.com_id }
        Mispichoshelper.getNotes(params).then(response => setNotes(response.payload));
    }

    const transformOrdersToTableData = () => {
        const tableData = [];

        if (orders && orders.length > 0) {
            orders.forEach(order => {
                const address = order.address
                    ? `${order.address.dom_calle || ''} ${order.address.dom_altura || ''} ${order.address.dom_piso ? `Piso ${order.address.dom_piso}` : ''} - ${order.address.dom_ciudad || ''} (${order.address.dom_codigo_postal || ''})`
                    : 'N/A';

                // Pasar los productos completos con sus datos
                const productos = order.products || [];

                const cliente = order.buyer
                    ? `${order.buyer.nombre || ''} ${order.buyer.apellido || ''} ${isAdmin && order.buyer.email ? order.buyer.email : ''}`
                    : 'N/A';

                // Obtener el estado logístico
                let estadoLogistico = '-';
                if (order.actual_logistic_status) {
                    estadoLogistico = order.actual_logistic_status;
                }

                // Obtener el estado del paquete
                const estadoPaquete = order.actual_package_status || 'N/A';
                const estadoIDPaquete = order.status ? order.status.id : null;
                const estadoIDLogistico = order.transport_order && order.transport_order.status ? order.transport_order.status.id : null;

                // Obtener el nombre del driver (solo el primer nombre)
                const driverName = order.transport_order?.user?.nombre || null;
                const driverFirstName = driverName;

                tableData.push({
                    key: order.id,
                    orden: order.id,
                    shop_order_number: order.com_id,
                    tracking_number: order.tracking_number,
                    fake_order: order.order.com_fake_order,
                    fechaEntrega: order.delivery_date_formatted,
                    estadoPaquete: estadoPaquete,
                    estadoIDPaquete: estadoIDPaquete,
                    estadoIDLogistico: estadoIDLogistico,
                    domicilio: address,
                    productos: productos,
                    monto: `${(parseCurrency(order.total_real))}`,
                    cliente: cliente,
                    fechaCreacionOrdenCompra: order.order.com_fecha_in,
                    petshop: order.puv_nombre || 'N/A',
                    estadoLogistico: estadoLogistico,
                    driverFirstName: driverFirstName,
                    delayed: order.delayed || false,
                    transport_order: order.transport_order,
                    has_notes: order.has_notes || false,
                    payment_method_id: order.payment_method_id,
                });
            });
        }

        return tableData;
    };

    const tableData = transformOrdersToTableData();

    const columns = [
        {
            title: 'Orden',
            dataIndex: 'orden',
            key: 'orden',
            render: (text, record) => {
                const content = (
                    <div>
                        <Notes state={{ key: record.shop_order_number }} />
                    </div>
                );

                return {
                    props: {
                        style: { backgroundColor: (record.nota && record.nota.length > 0) || (record.cant_notes && record.cant_notes > 0) ? 'lightyellow' : null }
                    },
                    children: (
                        <div style={{ fontSize: '12px', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <span>OE: <strong>{text}</strong></span>
                            <span>OC: <strong>{record.shop_order_number}</strong></span>
                            <span>Tracking: <strong>{record.tracking_number}</strong></span>
                            {record.fake_order && (<span style={{ color: 'red' }}><strong>Es Orden de Solución</strong></span>)}
                            {record.has_notes && (

                                <Popover content={content} title="Nota:">
                                    <span><FontAwesomeIcon icon={faStickyNote} /> Ver nota<strong>{record.has_notes}</strong></span>
                                </Popover>
                            )}
                        </div>
                    )
                }
            }
        },
        {
            title: 'Fecha entrega',
            dataIndex: 'fechaEntrega',
            key: 'fechaEntrega',
            width: '110px'
        },
        {
            title: 'Estado paquete',
            dataIndex: 'estadoPaquete',
            key: 'estadoPaquete',
            render: (status, record) => {
                const color = getPackingStatusColor(record.estadoIDPaquete);
                return (
                    <Tag color={color} style={{ fontWeight: '500', borderRadius: '100px', fontSize: '12px', color: '#484848ff' }}>
                        {status || 'N/A'}
                    </Tag>
                );
            }
        },
        {
            title: 'Domicilio',
            dataIndex: 'domicilio',
            key: 'domicilio',
            width: '150px',
        },
        {
            title: 'Productos',
            dataIndex: 'productos',
            key: 'productos',
            render: (productos) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {productos && productos.length > 0 ? (
                        productos.map((product, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1
                                }}>
                                    <div style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#333',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '200px',
                                        textAlign: 'left'
                                    }}>
                                        {product.pro_nombre_completo}
                                    </div>
                                    <div style={{
                                        fontSize: '11px',
                                        color: '#999',
                                        textAlign: 'left'
                                    }}>
                                        EAN: {product.prv_codigo_barra || 'N/A'}
                                        {product.quantity >= 1 && (
                                            <span style={{
                                                color: 'black',
                                                borderRadius: '12px',
                                                padding: '2px 4px',
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}>
                                                x{product.quantity}
                                            </span>
                                        )}
                                    </div>
                                </div>

                            </div>
                        ))
                    ) : (
                        <span style={{ color: '#999' }}>Sin productos</span>
                    )}
                </div>
            )
        },
        {
            title: 'Monto',
            dataIndex: 'monto',
            key: 'monto',
            width: '120px',
            render: (amount, row) => {
                return (
                    <>
                        <p>{amount}</p>
                        <p>{row.payment_method_id === 1 ? <Tag color="blue">Efectivo</Tag> : <Tag color="green">Tarjeta</Tag>}</p>
                    </>
                )
            }
        },
        {
            title: 'Fecha de Venta',
            dataIndex: 'fechaCreacionOrdenCompra',
            key: 'fechaCreacionOrdenCompra',
        },
        {
            title: 'Cliente',
            dataIndex: 'cliente',
            key: 'cliente',
            width: '130px',
        },
        ...(isAdmin ? [{
            title: 'Petshop',
            dataIndex: 'petshop',
            key: 'petshop',
        }] : []),
        {
            title: 'Estado logístico',
            dataIndex: 'estadoLogistico',
            key: 'estadoLogistico',
            render: (status, record) => {
                const color = getLogisticStatusColor(record.estadoIDLogistico);
                const secondDeliveryAttempt = record.transport_order?.second_delivery_attempt;

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                        <div style={{ gap: '8px', position: 'relative' }}>
                            <Tag color={color} style={{ fontWeight: '500', borderRadius: '100px', fontSize: '12px', color: '#484848ff' }}>
                                {status || '-'}
                            </Tag>
                            {record.delayed && (
                                <Tooltip title="Pedido demorado">
                                    <Icon type="clock-circle" theme="filled" style={{ fontSize: '16px', color: '#f6b83bff', margin: '0px', position: 'absolute', top: '10px', right: '-10px' }} />
                                </Tooltip>
                            )}
                        </div>
                        {secondDeliveryAttempt && (
                            <div style={{ fontSize: '10px', color: '#666', paddingLeft: '2px' }}>
                                <div style={{ textAlign: 'left' }}>
                                    <strong>1er intento:</strong> {moment(secondDeliveryAttempt.first_attempt).format('DD/MM/YYYY [a las] HH:mm')}
                                </div>
                                <div style={{ textAlign: 'left' }}>
                                    <strong>Próximo intento:</strong> {moment(secondDeliveryAttempt.second_attempt).format('DD/MM/YYYY [a las] HH:mm')}
                                </div>
                            </div>
                        )}
                        {record.driverFirstName && (
                            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                                🚚 {record.driverFirstName} repartidor
                            </div>
                        )}
                    </div>
                );
            }
        },
    ];

    return (
        <div style={styles.container}>
            <style>{`
                @keyframes slideInFromRight {
                    0% {
                        transform: translateY(30px);
                        opacity: 0;
                    }
                    100% {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                .animated-button {
                    animation: slideInFromRight 0.4s ease-out forwards;
                    opacity: 0;
                }

                .animated-button-delay-0 {
                    animation-delay: 0s;
                }

                .animated-button-delay-1 {
                    animation-delay: 0.15s;
                }

                .animated-button-delay-2 {
                    animation-delay: 0.3s;
                }

                .animated-button-delay-3 {
                    animation-delay: 0.45s;
                }
            `}</style>
            <div style={{ padding: '0px 0px 10px 0px' }}>
                <h1 style={styles.title}>Dashboard Operativo</h1>
                <h1 style={styles.subtitle}>Gestión de pedidos del Marketplace</h1>
            </div>

            <div style={styles.subcontainer}>
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px' }}>
                    <FontAwesomeIcon icon={faInfoCircle} color="rgba(227, 184, 56, 1)" size="2x" />
                    <span style={{ fontSize: '20px' }}>Alertas de logítica</span>
                </div>

                <div style={{ ...styles.grid, display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '160px' }} >
                    <div style={{ ...styles.grid, width: '78%', padding: '10px' }}>
                        <DashboardIndicator
                            icon={<Icon type="clock-circle" theme="filled" style={{ fontSize: '16px', color: '#f6b83bff' }} />}
                            title="Pedidos demorados"
                            footerNote={"Entrégalos urgente para evitar la caída en ventas"}
                            value={counters.delayed}
                            color="#f6b83bff"
                            isSelected={selectedIndicator === 'demorados'}
                            onClick={() => handleIndicatorClick('demorados')}
                            loading={loadingOrders}
                        />
                        <DashboardIndicator
                            icon={<span style={styles.icon}><Icon type="rollback" style={{ color: "#b40101ff" }} /></span>}
                            title="Retirar del cliente"
                            value={counters.pick_up_from_client_address}
                            color="#b40101ff"
                            footerNote="Debes ir a retirar estos pedidos por devoluciones"
                            isSelected={selectedIndicator === 'retirar'}
                            onClick={() => handleIndicatorClick('retirar')}
                            loading={loadingOrders}
                        />

                        <DashboardIndicator
                            icon={<span style={styles.icon}><Icon type="undo" style={{ color: "#a9a9a9ff" }} /></span>}
                            title="Repartidor debe devolver"
                            value={counters.return_to_origin}
                            footerNote={"Pedir al repartidor estos paquetes"}
                            color="#a9a9a9ff"
                            isSelected={selectedIndicator === 'retornar'}
                            onClick={() => handleIndicatorClick('retornar')}
                            loading={loadingOrders}
                        />
                    </div>

                    <div style={{ width: '12%' }}>
                        <DashboardIndicator
                            icon={<FontAwesomeIcon icon={faTruck} />}
                            title="En camino"
                            value={counters.in_transit}
                            color="#7a7a7aff"
                            isSelected={selectedIndicator === 'encamino'}
                            onClick={() => handleIndicatorClick('encamino')}
                            loading={loadingOrders}
                        />
                    </div>
                </div>

            </div>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', justifyContent: 'flex-start', alignItems: 'center' }}>
                <Button
                    onClick={() => handlePeriodClick('hoy')}
                    style={{
                        backgroundColor: selectedPeriod === 'hoy' ? 'rgba(41, 84, 255, 1)' : '#ffffff',
                        borderColor: selectedPeriod === 'hoy' ? 'rgba(41, 84, 255, 1)' : 'rgba(101, 101, 101, 1)',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: selectedPeriod === 'hoy' ? 'white' : 'grey',
                        transition: 'all 0.3s ease'
                    }}>
                    Envíos hoy
                </Button>

                <Select
                    mode="multiple"
                    value={selectedDeliveryTime.map(dt => dt.id)}
                    onChange={(values) => {
                        if (!values || values.length === 0) {
                            setSelectedDeliveryTime([]);
                        } else {
                            const selectedTimes = values.map(value =>
                                deliveryTimes.find(time => time.id === value)
                            ).filter(Boolean);
                            setSelectedDeliveryTime(selectedTimes);
                        }
                    }}
                    style={{
                        width: '240px',
                    }}
                    placeholder="Todas las franjas"
                    allowClear
                >
                    {deliveryTimes.map((time) => (
                        <Select.Option key={time.id} value={time.id}>
                            {time.formatted}
                        </Select.Option>
                    ))}
                </Select>

                <Button
                    onClick={() => handlePeriodClick('proximos')}
                    style={{
                        backgroundColor: selectedPeriod === 'proximos' ? 'rgba(41, 84, 255, 1)' : '#ffffff',
                        borderColor: selectedPeriod === 'proximos' ? 'rgba(41, 84, 255, 1)' : 'rgba(101, 101, 101, 1)',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: selectedPeriod === 'proximos' ? 'white' : 'grey',
                        transition: 'all 0.3s ease'
                    }}
                >
                    Próximos días
                </Button>

                <Divider type="vertical" style={{ height: '60px', borderLeft: '2px solid #d4d4d4' }} />

                <div style={{ position: 'relative' }}>
                    <Button
                        onClick={() => setDatePickerVisible(!datePickerVisible)}
                        style={{
                            backgroundColor: customDateRange ? 'rgba(41, 84, 255, 1)' : '#ffffff',
                            borderColor: customDateRange ? 'rgba(41, 84, 255, 1)' : 'rgba(101, 101, 101, 1)',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: customDateRange ? 'white' : 'grey',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <Icon type="calendar" />
                        {customDateRange
                            ? `${customDateRange[0].format('DD/MM')} - ${customDateRange[1].format('DD/MM')}`
                            : 'Seleccionar período'
                        }
                    </Button>
                    {datePickerVisible && (
                        <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1000, marginTop: '8px' }}>
                            <RangePicker
                                open={datePickerVisible}
                                onChange={handleDateRangeChange}
                                onOpenChange={(open) => setDatePickerVisible(open)}
                                style={{ visibility: 'hidden', position: 'absolute' }}
                            />
                        </div>
                    )}
                </div>
            </div>


            <div style={{ ...styles.grid, width: '78%', padding: '10px', height: '160px' }}>
                <DashboardIndicator
                    icon={<Icon type="unordered-list" />}
                    title="Todos"
                    width="30%"
                    value={counters.all_orders}
                    isSelected={selectedIndicator === 'todos'}
                    onClick={() => handleIndicatorClick('todos')}
                    loading={loadingOrders}
                />

                <DashboardIndicator
                    icon={<Icon type="printer" />}
                    title="Pendientes de imprimir etiqueta"
                    value={counters.pending_to_print_label}
                    width="80%"
                    footerNote="Pedidos que debes preparar"
                    isSelected={selectedIndicator === 'imprimir'}
                    onClick={() => handleIndicatorClick('imprimir')}
                    loading={loadingOrders}
                />

                <DashboardIndicator
                    icon={<Icon type="code-sandbox" />}
                    title="Pendientes de despachar"
                    value={counters.to_be_dispatched}
                    footerNote="Cuando el repartidor escanee la etiqueta se dará por despachado"
                    isSelected={selectedIndicator === 'despachar'}
                    onClick={() => handleIndicatorClick('despachar')}
                    loading={loadingOrders}
                />

                <DashboardIndicator
                    icon={<Icon type="close-circle" style={{ color: '#ef4444' }} />}
                    title="Cancelada - No despachar"
                    value={counters.canceled}
                    width="80%"
                    color="#ef4444"
                    footerNote="Esta venta se canceló, no debes despacharla."
                    isSelected={selectedIndicator === 'cancelada'}
                    onClick={() => handleIndicatorClick('cancelada')}
                    loading={loadingOrders}
                />
            </div>

            {/* Buscador y filtros */}
            <div style={styles.searchContainer}>
                <Input
                    placeholder="Buscar por N° de orden..."
                    prefix={<Icon type="search" style={{ color: '#999' }} />}
                    style={styles.searchInput}
                    value={tempSearchOrderNumber}
                    onChange={(e) => setTempSearchOrderNumber(e.target.value)}
                    onPressEnter={() => setSearchOrderNumber(tempSearchOrderNumber)}
                />
                <Button style={styles.filterButton} onClick={() => setFilterModalVisible(true)}>
                    <Icon type="filter" />
                    Filtros
                </Button>
                {hasActiveFilters() && (
                    <Button
                        style={{
                            ...styles.filterButton,
                            backgroundColor: '#ff4d4f',
                            borderColor: '#ff4d4f',
                            color: 'white'
                        }}
                        onClick={handleClearFilters}
                    >
                        <Icon type="close-circle" />
                        Limpiar filtros
                    </Button>
                )}
            </div>

            {/* Modal de Filtros */}
            <Modal
                visible={filterModalVisible}
                onCancel={() => setFilterModalVisible(false)}
                footer={null}
                width={700}
                maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.71)' }}
            >
                <div style={styles.modalContent}>
                    {/* Fechas */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="calendar" style={{ marginRight: '6px' }} />
                                    Desde
                                </label>
                                <DatePicker
                                    placeholder="Seleccionar fecha"
                                    style={{ width: '100%' }}
                                    value={filters.fechaDesde}
                                    onChange={(date) => handleFilterChange('fechaDesde', date)}
                                />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="calendar" style={{ marginRight: '6px' }} />
                                    Hasta
                                </label>
                                <DatePicker
                                    placeholder="Seleccionar fecha"
                                    style={{ width: '100%' }}
                                    value={filters.fechaHasta}
                                    onChange={(date) => handleFilterChange('fechaHasta', date)}
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Montos */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="dollar" style={{ marginRight: '6px' }} />
                                    Monto desde
                                </label>
                                <InputNumber
                                    prefix="$"
                                    placeholder="0"
                                    style={{ width: '100%' }}
                                    value={filters.montoDesde}
                                    onChange={(value) => handleFilterChange('montoDesde', value)}
                                />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="dollar" style={{ marginRight: '6px' }} />
                                    Monto hasta
                                </label>
                                <InputNumber
                                    prefix="$"
                                    placeholder="Sin límite"
                                    style={{ width: '100%' }}
                                    value={filters.montoHasta}
                                    onChange={(value) => handleFilterChange('montoHasta', value)}
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Método de pago y Estado del paquete */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="credit-card" style={{ marginRight: '6px' }} />
                                    Método de pago
                                </label>
                                <Select
                                    defaultValue="todos"
                                    style={{ width: '100%' }}
                                    value={filters.metodoPago}
                                    onChange={(value) => handleFilterChange('metodoPago', value)}
                                >
                                    <Select.Option value="todos">Todos</Select.Option>
                                    <Select.Option value="1">Efectivo</Select.Option>
                                    <Select.Option value="2">Tarjeta</Select.Option>
                                </Select>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="inbox" style={{ marginRight: '6px' }} />
                                    Estado del paquete
                                </label>
                                <Select
                                    defaultValue="todos"
                                    style={{ width: '100%' }}
                                    value={filters.estadoPaquete}
                                    onChange={(value) => handleFilterChange('estadoPaquete', value)}
                                >
                                    <Select.Option value="todos">Todos</Select.Option>
                                    {packingStatuses.map((status) => (
                                        <Select.Option key={status.id} value={status.id}>
                                            {status.text_pet}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                    </Row>

                    {/* Estado logístico y Repartidor */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="car" style={{ marginRight: '6px' }} />
                                    Estado logístico
                                </label>
                                <Select
                                    defaultValue="todos"
                                    style={{ width: '100%' }}
                                    value={filters.estadoLogistico}
                                    onChange={(value) => handleFilterChange('estadoLogistico', value)}
                                >
                                    <Select.Option value="todos">Todos</Select.Option>
                                    {transportStatuses.map((status) => (
                                        <Select.Option key={status.id} value={status.id}>
                                            {status.text_pet}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="user" style={{ marginRight: '6px' }} />
                                    Repartidor
                                </label>
                                <Select
                                    defaultValue="todos"
                                    style={{ width: '100%' }}
                                    value={filters.repartidor}
                                    onChange={(value) => handleFilterChange('repartidor', value)}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        const children = option.props.children;
                                        if (!children) return false;
                                        return children.toString().toLowerCase().includes(input.toLowerCase());
                                    }}
                                >
                                    <Select.Option value="todos">Todos</Select.Option>
                                    {drivers.map((driver) => (
                                        <Select.Option key={driver.id} value={driver.id}>
                                            {driver.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                    </Row>

                    {/* Petshop - Solo para admin */}
                    {isAdmin && (
                        <Row gutter={16}>
                            <Col span={12}>
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>
                                        <Icon type="shop" style={{ marginRight: '6px' }} />
                                        Petshop
                                    </label>
                                    <Select
                                        placeholder="Seleccionar petshop"
                                        style={{ width: '100%' }}
                                        value={filters.puv_id}
                                        onChange={(value) => handleFilterChange('puv_id', value)}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                            const children = option.props.children;
                                            if (!children) return false;
                                            return children.toString().toLowerCase().includes(input.toLowerCase());
                                        }}
                                    >
                                        <Select.Option value={null}>Todos</Select.Option>
                                        {petshops.map((petshop) => (
                                            <Select.Option key={petshop.id} value={petshop.id}>
                                                {petshop.nombre}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    )}

                    {/* Provincia y Localidad */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="global" style={{ marginRight: '6px' }} />
                                    Provincia
                                </label>
                                <Select
                                    style={{ width: '100%' }}
                                    value={filters.provincia}
                                    disabled={true}
                                >
                                    <Select.Option value="Buenos Aires">Buenos Aires</Select.Option>
                                </Select>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="environment" style={{ marginRight: '6px' }} />
                                    Localidad
                                </label>
                                <Select
                                    placeholder="Seleccionar localidad"
                                    style={{ width: '100%' }}
                                    value={filters.localidad}
                                    onChange={(value) => handleFilterChange('localidad', value)}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        const children = option.props.children;
                                        if (!children) return false;
                                        return children.toString().toLowerCase().includes(input.toLowerCase());
                                    }}
                                >
                                    {localities.map((locality) => (
                                        <Select.Option key={locality.value} value={locality.value}>
                                            {locality.text}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                    </Row>

                    {/* Barrio y Código Postal */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="home" style={{ marginRight: '6px' }} />
                                    Barrio
                                </label>
                                <Select
                                    placeholder="Seleccionar barrio"
                                    style={{ width: '100%' }}
                                    value={filters.barrio}
                                    onChange={(value) => handleFilterChange('barrio', value)}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        const children = option.props.children;
                                        if (!children) return false;
                                        return children.toString().toLowerCase().includes(input.toLowerCase());
                                    }}
                                >
                                    {neighborhoods.map((neighborhood) => (
                                        <Select.Option key={neighborhood.value} value={neighborhood.value}>
                                            {neighborhood.text}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <Icon type="pushpin" style={{ marginRight: '6px' }} />
                                    Código Postal
                                </label>
                                <Input
                                    placeholder="Ej: C1414"
                                    value={filters.codigoPostal}
                                    onChange={(e) => handleFilterChange('codigoPostal', e.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Botones */}
                    <div style={styles.modalFooter}>
                        <Button size="large" onClick={handleClearFilters} style={{ borderRadius: '8px' }}>
                            Cerrar
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={handleApplyFilters}
                            style={{ borderRadius: '8px', marginLeft: '12px' }}
                        >
                            Aplicar filtros
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Listado de órdenes */}
            <div style={styles.ordersContainer}>
                <div style={styles.ordersHeader}>
                    <h2 style={styles.ordersTitle}>Listado de Órdenes</h2>
                    <div style={styles.ordersControls}>
                        {(() => {
                            const actionButton = getActionButton();

                            if (!actionButton) return null;

                            if (actionButton.type === 'warning') {
                                return (
                                    <div style={{
                                        backgroundColor: '#fff3cd',
                                        border: '1px solid #ffc107',
                                        borderRadius: '8px',
                                        padding: '8px 16px',
                                        marginRight: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <Icon type="warning" style={{ color: '#ff9800' }} />
                                        <span style={{ color: '#856404', fontSize: '14px', fontWeight: '500' }}>
                                            {actionButton.message}
                                        </span>
                                    </div>
                                );
                            }

                            if (actionButton.type === 'multiple') {
                                return (
                                    <>
                                        {actionButton.buttons.map((button, index) => (
                                            <Button
                                                key={index}
                                                className={`animated-button animated-button-delay-${index}`}
                                                style={{
                                                    ...styles.viewButton,
                                                    marginRight: '8px',
                                                    backgroundColor: button.color,
                                                    borderColor: 'rgba(98, 98, 98, 1)',
                                                    gap: '10px',
                                                    color: button.textColor
                                                }}
                                                onClick={button.action}
                                            >
                                                <Icon type="printer" style={{ fontSize: '20px' }} />
                                                {button.label} ({selectedRowKeys.length})
                                            </Button>
                                        ))}
                                    </>
                                );
                            }

                            return (
                                <Button
                                    className="animated-button animated-button-delay-0"
                                    style={{
                                        ...styles.viewButton,
                                        marginRight: '8px',
                                        backgroundColor: actionButton.color,
                                        borderColor: actionButton.color,
                                        color: actionButton.textColor
                                    }}
                                    onClick={actionButton.action}
                                >
                                    {actionButton.label} ({selectedRowKeys.length})
                                </Button>
                            );
                        })()}
                        {/*DESHABILITADO POR EL MOMENTO*/ false && selectedRowKeys.length >= 1 && selectedOrders.every(order => order.transport_order?.status.id !== TRANSPORT_ORDER_STATUS.RETURN_TO_ORIGIN || order.transport_order?.status.id !== TRANSPORT_ORDER_STATUS.RETURNED_TO_ORIGIN) && selectedOrders.some(order => order.status?.id !== PACKING_ORDER_STATUS.CANCELED || order.status?.id !== PACKING_ORDER_STATUS.SHIPPED) && (
                            <Button
                                className="animated-button animated-button-delay-1"
                                style={{
                                    ...styles.viewButton,
                                    marginRight: '8px',
                                    backgroundColor: '#347e34',
                                    borderColor: '#6fd976',
                                    color: '#fff'
                                }}
                                onClick={handleCompletarVenta}
                            >
                                <Icon type="close-circle" />
                                Completar venta
                            </Button>
                        )}
                        {/* Botón Cancelar venta - Solo disponible para una orden a la vez */}
                        {selectedRowKeys.length === 1 && selectedOrders.some(order => order.status?.id !== PACKING_ORDER_STATUS.CANCELED || order.status?.id !== PACKING_ORDER_STATUS.SHIPPED) && (
                            <Button
                                className="animated-button animated-button-delay-1"
                                style={{
                                    ...styles.viewButton,
                                    marginRight: '8px',
                                    backgroundColor: '#dc2626',
                                    borderColor: '#dc2626',
                                    color: '#fff'
                                }}
                                onClick={handleCancelarVenta}
                            >
                                <Icon type="close-circle" />
                                Cancelar venta
                            </Button>
                        )}
                        {selectedRowKeys.length > 0 && (
                            <ExcelFile
                                element={
                                    <Button
                                        className="animated-button animated-button-delay-2"
                                        style={{ ...styles.viewButton, marginRight: '8px', backgroundColor: '#ffffffff', borderColor: '#252525ff', color: '#2c2c2cff' }}
                                    >
                                        <Icon type="download" />
                                        Descargar Excel ({selectedRowKeys.length})
                                    </Button>
                                }
                                filename={`ordenes_${moment().format('YYYY-MM-DD_HH-mm')}`}
                            >
                                <ExcelSheet data={prepareDataForExcel()} name="Órdenes">
                                    <ExcelColumn label="Orden de compra" value="purchaseOrder" />
                                    <ExcelColumn label="Orden de empaquetado" value="packingOrder" />
                                    <ExcelColumn label="Número de Tracking" value="trackingNumber" />
                                    <ExcelColumn label="Fecha Entrega" value="fechaEntrega" />
                                    <ExcelColumn label="Estado Paquete" value="estadoPaquete" />
                                    <ExcelColumn label="Estado Logístico" value="estadoLogistico" />
                                    <ExcelColumn label="Domicilio" value="domicilio" />
                                    <ExcelColumn label="Productos" value="productos" />
                                    <ExcelColumn label="Sku" value="sku" />
                                    <ExcelColumn label="Método de pago" value="metodoPago" />
                                    <ExcelColumn label="Monto" value="monto" />
                                    <ExcelColumn label="Fecha de Venta" value="fechaCreacionOrdenCompra" />
                                    <ExcelColumn label="Cliente" value="cliente" />
                                    {[
                                        isAdmin && <ExcelColumn key="dni" label="DNI" value="clienteDNI" />,
                                        isAdmin && <ExcelColumn key="tel" label="Teléfono" value="clienteTelefono" />,
                                        isAdmin && <ExcelColumn key="email" label="Email" value="clienteEmail" />
                                    ].filter(Boolean)}
                                    <ExcelColumn label="Petshop" value="petshop" />
                                    <ExcelColumn label="Repartidor" value="repartidor" />
                                </ExcelSheet>
                            </ExcelFile>
                        )}

                        {/* Boton para Paginado: Activar y Desactivar */}
                        <Button
                            style={{
                                ...styles.viewButton,
                                backgroundColor: !paginationCheck ? 'rgba(41, 84, 255, 1)' : '#ffffff',
                                color: !paginationCheck ? 'white' : 'grey',
                                borderColor: !paginationCheck ? 'rgba(41, 84, 255, 1)' : 'rgba(101, 101, 101, 1)',
                                marginRight: '16px'
                            }}
                            onClick={() => {
                                if (paginationCheck) {
                                    // Desactivar paginación
                                    setPaginationCheck(false);
                                } else {
                                    // Activar paginación con valores por defecto
                                    setPaginationCheck(true);
                                }
                            }}
                        >
                            <Icon type={!paginationCheck ? "check-square" : "border"} />
                            Ver todos los pedidos
                        </Button>

                        {/* Boton para Vista Tabla */}
                        <Button
                            // type={viewMode === 'lista' ? 'primary' : 'default'}
                            style={{ ...styles.viewButton, backgroundColor: viewMode === 'lista' ? 'rgba(41, 84, 255, 1)' : '#ffffff', color: viewMode === 'lista' ? 'white' : 'grey', borderColor: viewMode === 'lista' ? 'rgba(41, 84, 255, 1)' : 'rgba(101, 101, 101, 1)' }}
                            onClick={() => setViewMode('lista')}
                        >
                            <Icon type="bars" />
                            Lista
                        </Button>
                        {/* Boton para Vista Mapa */}
                        <Button
                            style={{ ...styles.viewButton, backgroundColor: viewMode === 'mapa' ? 'rgba(41, 84, 255, 1)' : '#ffffff', color: viewMode === 'mapa' ? 'white' : 'grey', borderColor: viewMode === 'mapa' ? 'rgba(41, 84, 255, 1)' : 'rgba(101, 101, 101, 1)' }}
                            onClick={() => setViewMode('mapa')}
                        >
                            <Icon type="environment" />
                            Mapa
                        </Button>
                    </div>
                </div>

                {/* Filtros activos */}
                {getActiveFilters().length > 0 && (
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        padding: '12px 0',
                        alignItems: 'center'
                    }}>
                        <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                            Filtros aplicados:
                        </span>
                        {getActiveFilters().map((filter) => (
                            <Tag
                                key={filter.key}
                                closable
                                onClose={(e) => {
                                    e.preventDefault();
                                    filter.onRemove();
                                }}
                                style={{
                                    fontSize: '13px',
                                    padding: '4px 12px',
                                    borderRadius: '6px',
                                    backgroundColor: '#e6f7ff',
                                    borderColor: '#91d5ff',
                                    color: '#0050b3'
                                }}
                            >
                                {filter.label}
                            </Tag>
                        ))}
                        {getActiveFilters().length > 1 && (
                            <Button
                                size="small"
                                onClick={handleClearFilters}
                                style={{
                                    fontSize: '12px',
                                    height: '24px',
                                    borderRadius: '6px',
                                    color: '#666'
                                }}
                            >
                                Limpiar todos
                            </Button>
                        )}
                    </div>
                )}

                {/* Tabla o Mapa */}
                {viewMode === 'lista' ? (
                    <Table
                        columns={columns}
                        dataSource={tableData}
                        loading={loadingOrders}
                        locale={{ emptyText: 'No se encontraron pedidos con este filtro' }}
                        pagination={false}
                        style={{ backgroundColor: 'white', borderRadius: '8px' }}
                        rowSelection={{
                            selectedRowKeys,
                            onChange: handleSelectChange,
                            getCheckboxProps: () => ({
                                disabled: false,
                            })
                        }}
                        onRow={(record) => ({
                            onDoubleClick: (event) => {
                                // Solo abrir el modal si no se hizo click en el checkbox
                                if (!event.target.closest('.ant-checkbox-wrapper')) {
                                    const order = orders.find(o => o.id === record.orden);
                                    if (order) handleOrderClick(order);
                                }
                            },
                            style: { cursor: 'pointer', fontSize: '12px' }
                        })}
                    />
                ) : (
                    <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '20px' }}>
                        {loadingOrders ? (
                            <div style={{ textAlign: 'center', padding: '40px' }}>
                                <Icon type="loading" style={{ fontSize: '32px' }} />
                            </div>
                        ) : orders.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                                No se encontraron pedidos con este filtro
                            </div>
                        ) : (
                            <LeafletPackingOrders
                                orders={orders}
                                id="packingOrdersMap"
                                onOrderClick={handleOrderClick}
                                onOrderSelect={handleMapOrderSelect}
                                selectedOrderKeys={selectedRowKeys}
                                getPackingStatusColor={getPackingStatusColor}
                            />
                        )}
                    </div>
                )}

                {/* Controles de paginación */}
                {paginationCheck ?
                    <div style={styles.paginationContainer}>
                        <div style={styles.paginationInfo}>
                            Mostrando {paginationFrom || 0} a {paginationTo || 0} de {paginationTotal} resultados
                        </div>
                        <Pagination
                            current={paginationCurrentPage}
                            pageSize={paginationPerPage}
                            total={paginationTotal}
                            onChange={(page) => getOrders(page)}
                            showSizeChanger={false}
                            disabled={loadingOrders}
                            style={{ marginTop: '10px' }}
                        />
                    </div>
                    : null
                }
            </div>

            {/* Modal de detalle de orden */}
            {selectedOrder && (
                <Modal
                    visible={orderDetailVisible}
                    onCancel={() => setOrderDetailVisible(false)}
                    footer={null}
                    width={1200}
                    maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.71)' }}
                    title={
                        <div>
                            <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>Orden #{selectedOrder.id}</h2>
                            <span>Orden compra #{selectedOrder.com_id}</span>
                        </div>
                    }
                >
                    <div style={{ display: 'flex', gap: '40px', padding: '20px 0' }}>
                        {/* Información del pedido */}
                        <div style={{ flex: 1 }}>
                            <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '20px' }}>Información del pedido</h3>

                            {/* Grid 2 columnas */}
                            <Row gutter={[24, 24]} style={{ marginBottom: '20px' }}>
                                {/* Primera fila */}
                                <Col span={12}>
                                    {/* Cliente */}
                                    <OrderInfoSection icon="user" title="Cliente">
                                        <div style={{ fontWeight: '600' }}>Nombre: {selectedOrder.buyer?.nombre || ''} {selectedOrder.buyer?.apellido || ''}</div>
                                        {isAdmin && <div style={{ color: '#666' }}>Dni: {selectedOrder.buyer?.dni || 'N/A'}</div>}
                                        {isAdmin && <div style={{ color: '#666' }}>Tel: {selectedOrder.buyer?.telefono || 'N/A'}</div>}
                                        {isAdmin && <div style={{ color: '#666' }}>Email: {selectedOrder.buyer?.email || 'N/A'}</div>}
                                    </OrderInfoSection>
                                </Col>
                                <Col span={12}>
                                    {/* Domicilio */}
                                    <OrderInfoSection icon="environment" title="Domicilio">
                                        <div style={{ color: '#333' }}>
                                            {selectedOrder.address
                                                ? `${selectedOrder.address.dom_calle || ''} ${selectedOrder.address.dom_altura || ''}, ${selectedOrder.address.dom_piso ? `Piso ${selectedOrder.address.dom_piso} Dto ${selectedOrder.address.dom_dpto || ''}` : ''}, ${selectedOrder.address.dom_ciudad || ''} (${selectedOrder.address.dom_codigo_postal || ''})`
                                                : 'N/A'
                                            }
                                        </div>
                                    </OrderInfoSection>
                                </Col>
                            </Row>

                            {/* Segunda fila */}
                            <Row gutter={[24, 24]} style={{ marginBottom: '20px' }}>
                                <Col span={12}>
                                    {/* Fecha de entrega */}
                                    <OrderInfoSection icon="clock-circle" title="Fecha de entrega">
                                        <div style={{ color: '#333' }}>
                                            {selectedOrder.delivery_date_formatted}
                                        </div>
                                    </OrderInfoSection>
                                </Col>
                                <Col span={12}>
                                    {/* Pago */}
                                    <OrderInfoSection icon="dollar" title="Pago">
                                        <div style={{ fontWeight: '600', fontSize: '20px' }}>
                                            {parseCurrency(selectedOrder.total_real)}
                                        </div>
                                        <div style={{ color: selectedOrder.payment_method_id == 1 ? '#ff7b00ff' : '#00c41aff', fontWeight: '500' }}>
                                            {selectedOrder.payment_method_id == 1 ? 'Cobrar en efectivo' : 'Pagado con tarjeta'}
                                        </div>
                                    </OrderInfoSection>
                                </Col>
                            </Row>

                            {/* Tercera fila - Repartidor */}
                            {selectedOrder.transport_order?.user && (
                                <Row gutter={[24, 24]} style={{ marginBottom: '20px' }}>
                                    <Col span={24}>
                                        <OrderInfoSection icon="car" title="Repartidor">
                                            <div style={{ fontWeight: '600', color: '#333' }}>
                                                {selectedOrder.transport_order.user.nombre} {selectedOrder.transport_order.user.apellido}
                                            </div>
                                        </OrderInfoSection>
                                    </Col>
                                </Row>
                            )}

                            {/* Productos */}
                            <ProductList products={selectedOrder.products || []} />
                        </div>

                        {/* Timeline del pedido */}
                        <OrderTimeline order={selectedOrder} />
                    </div>

                    {/* Datos de entrega */}
                    {(() => {
                        const deliveryHistoryEntry = selectedOrder.transport_order?.status_history?.find(
                            h => h.status?.id === TRANSPORT_ORDER_STATUS.DELIVERED
                        );

                        if (!deliveryHistoryEntry?.data) return null;

                        let deliveryData;
                        try {
                            deliveryData = JSON.parse(deliveryHistoryEntry.data);
                        } catch (e) {
                            return null;
                        }

                        if (!deliveryData || !deliveryData.receiver_data) return null;

                        return (
                            <div style={{
                                marginTop: '30px',
                                padding: '20px',
                                backgroundColor: '#f9fafb',
                                borderRadius: '12px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <h3 style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    marginBottom: '20px',
                                    color: '#333'
                                }}>
                                    <Icon type="check-circle" style={{ marginRight: '8px', color: '#4caf50' }} />
                                    Datos de Entrega
                                </h3>

                                <div style={{ display: 'flex', gap: '40px', alignItems: 'flex-start' }}>
                                    {/* Información del receptor */}
                                    <div style={{ flex: 1 }}>
                                        <div style={{ marginBottom: '12px' }}>
                                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>Recibido por:</div>
                                            <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>
                                                {deliveryData.receiver_data.fullName || 'N/A'}
                                            </div>
                                        </div>

                                        <div style={{ marginBottom: '12px' }}>
                                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>DNI:</div>
                                            <div style={{ fontSize: '15px', color: '#333' }}>
                                                {deliveryData.receiver_data.dni || 'N/A'}
                                            </div>
                                        </div>

                                        <div>
                                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>Relación:</div>
                                            <div style={{ fontSize: '15px', color: '#333' }}>
                                                {deliveryData.receiver_data.relationship || 'N/A'}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Firma */}
                                    {deliveryData.signature && (
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>Firma:</div>
                                            <div style={{
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                padding: '10px',
                                                backgroundColor: 'white',
                                                display: 'inline-block'
                                            }}>
                                                <img
                                                    src={`data:image/png;base64,${deliveryData.signature}`}
                                                    alt="Firma del receptor"
                                                    style={{
                                                        maxWidth: '300px',
                                                        maxHeight: '150px',
                                                        display: 'block'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })()}
                </Modal>
            )}

            {/* Modal de cancelación de venta */}
            <Modal
                visible={cancelSaleModalVisible}
                onCancel={() => {
                    setCancelSaleModalVisible(false);
                    setCancelMotive(null);
                    setCancelComment('');
                    setOutStockProducts([]);
                    setSelectedOutStockProducts([]);
                }}
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Icon type="close-circle" style={{ fontSize: '24px', color: '#dc2626' }} />
                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Cancelar venta</span>
                    </div>
                }
                footer={[
                    <Button
                        key="cancel"
                        loading={loadingOrders}
                        onClick={() => {
                            setCancelSaleModalVisible(false);
                            setCancelMotive(null);
                            setCancelComment('');
                            setOutStockProducts([]);
                            setSelectedOutStockProducts([]);
                        }}
                        style={{ borderRadius: '8px' }}
                    >
                        Cerrar
                    </Button>,
                    <Button
                        key="submit"
                        type="danger"
                        onClick={handleShowConfirmModal}
                        loading={loadingOrders}
                        style={{ borderRadius: '8px' }}
                        disabled={!cancelMotive}
                    >
                        Confirmar cancelación
                    </Button>
                ]}
                width={600}
            >
                <div style={{ padding: '20px 0' }}>
                    <p style={{ marginBottom: '20px', fontSize: '15px', color: '#666' }}>
                        Está a punto de cancelar esta venta.
                    </p>

                    {/*
                        Selección de motivo ocultada: las cancelaciones se realizan siempre por producto.
                        Descomentar este bloque para volver a permitir elegir entre "producto" y "logística".
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                            Motivo de cancelación *
                        </label>
                        <Select
                            value={cancelMotive}
                            onChange={handleCancelMotiveChange}
                            style={{ width: '100%' }}
                            placeholder="Seleccione un motivo"
                        >
                            <Select.Option value={MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO}>No puedo entregar por producto</Select.Option>
                            <Select.Option value={MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_LOGISTICA}>No puedo entregarlo por logística</Select.Option>
                        </Select>
                    </div>
                    */}

                    {cancelMotive === MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO && (
                        <div style={{ marginBottom: '20px' }}>
                            <h4>Seleccione los productos sin stock *</h4>
                            <label style={{ display: 'block', fontSize: '14px', marginBottom: '8px' }}>
                                Importante: Los productos que selecciones serán desactivados de tu catálogo y deberás reactivarlo cuando vuelvas a tener stock
                            </label>
                            {loadingOutStockProducts ? (
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                    <Spin tip="Cargando productos..." />
                                </div>
                            ) : outStockProducts.length > 0 ? (
                                <div style={{
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '6px',
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                }}>
                                    {outStockProducts.map((product) => (
                                        <div
                                            key={product.prv_id}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '12px',
                                                borderBottom: '1px solid #f0f0f0',
                                                backgroundColor: selectedOutStockProducts.some(p => p.prv_id === product.prv_id) ? '#f6ffed' : 'white'
                                            }}
                                        >
                                            <Checkbox
                                                checked={selectedOutStockProducts.some(p => p.prv_id === product.prv_id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedOutStockProducts([...selectedOutStockProducts, product]);
                                                    } else {
                                                        setSelectedOutStockProducts(selectedOutStockProducts.filter(p => p.prv_id !== product.prv_id));
                                                    }
                                                }}
                                            />
                                            <img
                                                src={product.photo_mobile || product.prv_foto_link}
                                                alt={product.prv_producto_nombre}
                                                style={{
                                                    width: '50px',
                                                    height: '50px',
                                                    objectFit: 'contain',
                                                    marginLeft: '12px',
                                                    marginRight: '12px',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: '500', fontSize: '13px' }}>
                                                    {product.prv_producto_nombre}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>
                                                    Cantidad: {product.cor_cantidad} | {product.var_name}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#1890ff' }}>
                                                    {parseCurrency(product.total_amount)}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{
                                    padding: '20px',
                                    textAlign: 'center',
                                    color: '#999',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '6px'
                                }}>
                                    No se encontraron productos para esta orden
                                </div>
                            )}
                            {selectedOutStockProducts.length > 0 && (
                                <div style={{ marginTop: '8px', fontSize: '12px', color: '#52c41a' }}>
                                    {selectedOutStockProducts.length} producto(s) seleccionado(s)
                                </div>
                            )}
                        </div>
                    )}

                    <div>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                            Comentarios adicionales (opcional)
                        </label>
                        <Input.TextArea
                            value={cancelComment}
                            onChange={(e) => setCancelComment(e.target.value)}
                            placeholder="Ingrese detalles adicionales sobre la cancelación..."
                            rows={4}
                            style={{ borderRadius: '6px' }}
                        />
                    </div>

                    <div style={{
                        marginTop: '20px',
                        padding: '12px',
                        backgroundColor: '#fef2f2',
                        borderLeft: '4px solid #dc2626',
                        borderRadius: '4px'
                    }}>
                        <p style={{ margin: 0, fontSize: '13px', color: '#991b1b' }}>
                            <Icon type="info-circle" style={{ marginRight: '6px' }} />
                            Esta acción no se puede deshacer y notificará a los clientes correspondientes. La cancelación está sujeta a:
                            <ul>
                                <li>Una reducción de las ventas por incumplimiento</li>
                                <li>Una potencial demanda del comprador debido al incumplimiento de la Ley Nacional de Defensa del Consumidor N° 24.240</li>
                            </ul>
                            Esta acción cancelará la venta seleccionada
                        </p>
                    </div>
                </div>
            </Modal>

            {/* Modal de confirmación de cancelación */}
            <Modal
                visible={confirmCancelModalVisible}
                onCancel={() => setConfirmCancelModalVisible(false)}
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Icon type="warning" style={{ fontSize: '24px', color: '#faad14' }} />
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Confirmar cancelación</span>
                    </div>
                }
                footer={[
                    <Button
                        key="back"
                        onClick={() => setConfirmCancelModalVisible(false)}
                        style={{ borderRadius: '8px' }}
                    >
                        Volver
                    </Button>,
                    <Button
                        key="confirm"
                        type="danger"
                        onClick={delegateCancelOrder}
                        loading={loadingOrders}
                        style={{ borderRadius: '8px' }}
                    >
                        Sí, cancelar venta
                    </Button>
                ]}
                width={500}
            >
                <div style={{ padding: '20px 0', textAlign: 'center' }}>
                    <Icon type="exclamation-circle" style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
                    <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                        ¿Está seguro que desea cancelar esta venta?
                    </p>
                    <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
                        Esta acción no se puede deshacer.
                    </p>
                    {cancelMotive === MispichosVars.PROBLEMA_PETSHOP_DELEGA_POR_PRODUCTO && selectedOutStockProducts.length > 0 && (
                        <div style={{
                            backgroundColor: '#fff7e6',
                            border: '1px solid #ffd591',
                            borderRadius: '6px',
                            padding: '12px',
                            textAlign: 'left'
                        }}>
                            <p style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px', color: '#d48806' }}>
                                Productos sin stock seleccionados:
                            </p>
                            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', color: '#8c6d1f' }}>
                                {selectedOutStockProducts.map((product) => (
                                    <li key={product.prv_id}>{product.prv_producto_nombre}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </Modal>

            {/* Modal de re-empaquetado */}
            <Modal
                visible={repackageModalVisible}
                onCancel={() => setRepackageModalVisible(false)}
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Icon type="redo" style={{ fontSize: '24px', color: '#ff9800' }} />
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Re empaquetar</span>
                    </div>
                }
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => setRepackageModalVisible(false)}
                        style={{ borderRadius: '8px' }}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="confirm"
                        type="primary"
                        onClick={handleConfirmRepackage}
                        loading={loadingOrders}
                        style={{ borderRadius: '8px', backgroundColor: '#ff9800', borderColor: '#ff9800' }}
                    >
                        Confirmar
                    </Button>
                ]}
                width={550}
            >
                <div style={{ padding: '20px 0' }}>
                    <p style={{ fontSize: '15px', color: '#333', marginBottom: '20px', lineHeight: '1.6' }}>
                        Los siguientes pedidos serán re-empaquetados. Esto quiere decir que las ordenes en cuestión que se encuentran en camino
                        deberán regresar al origen para ser re-empaquetadas con la nueva etiqueta.
                        ¿Está seguro que desea continuar?
                    </p>

                    <div style={{
                        backgroundColor: '#fff7e6',
                        border: '1px solid #ffd591',
                        borderRadius: '6px',
                        padding: '12px',
                        marginBottom: '20px'
                    }}>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#d48806' }}>
                            {selectedOrders.length} orden(es) seleccionada(s)
                        </p>
                    </div>

                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                            Tipo de etiqueta
                        </label>
                        <Select
                            value={repackageLabelType}
                            onChange={(value) => setRepackageLabelType(value)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option value="pdf">PDF</Select.Option>
                            <Select.Option value="zpl">ZPL (Zebra)</Select.Option>
                        </Select>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

const styles = {
    container: {
        padding: '20px 40px',
        backgroundColor: '#f5f5f5',
        minHeight: '100vh'
    },
    title: {
        fontSize: '30px',
        fontWeight: 'bold'
    },
    subtitle: {
        fontSize: '20px',
        color: '#a4a4a4ff',
    },
    grid: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '16px',
        padding: '20px',
        width: '100%',
    },
    icon: {
        fontSize: '24px'
    },
    subcontainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '20px',
        margin: '20px 0px',
        borderRadius: '15px',
        border: '1px solid #d4d4d4',
    },
    searchContainer: {
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        // marginTop: '40px',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
    searchInput: {
        flex: 1,
        height: '45px',
        fontSize: '15px',
        borderRadius: '8px'
    },
    filterButton: {
        height: '45px',
        padding: '0 24px',
        fontSize: '15px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    ordersContainer: {
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
    },
    ordersHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: '24px',
        position: 'sticky',
        top: 50,
        backgroundColor: 'white',
        zIndex: 100,
        padding: '16px 10px',
        marginLeft: '-10px',
        marginRight: '-10px',
        marginTop: '-10px'
    },
    ordersTitle: {
        fontSize: '24px',
        fontWeight: 'bold',
        margin: 0
    },
    ordersControls: {
        display: 'flex',
        alignItems: 'center'
    },
    viewButton: {
        marginRight: '8px',
        borderRadius: '8px',
        display: 'flex',
        color: 'white',
        padding: '20px',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        height: '36px'
    },
    mapButton: {
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        height: '36px'
    },
    modalContent: {
        padding: '20px 0'
    },
    formGroup: {
        marginBottom: '20px'
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: '600',
        color: '#333',
        marginBottom: '8px'
    },
    helpText: {
        display: 'block',
        fontSize: '12px',
        color: '#999',
        marginTop: '6px'
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingTop: '20px',
        borderTop: '1px solid #f0f0f0'
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '24px',
        padding: '16px 0'
    },
    paginationInfo: {
        fontSize: '14px',
        color: '#666',
        marginBottom: '8px'
    }
};

export default DashboardPetshop;
